import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Modal, CheckboxLabel } from '@weezevent/nacre';
import LoadingCard from '../../../../components/loadingCard';
import { isValidEmail } from '../../../order/actions/utils';
import useAppContext from '../../../../context/useAppContext';
import { useIsEmailingBlocked } from '../../../../helpers/useIsEmailingBlocked';

function ValidationModal({ form, setForm, handleSubmit, onConstructAttendees, order, isSubmitting }) {
    const [{ feature_flags }] = useAppContext();
    const { t } = useTranslation();

    const handleCancel = React.useCallback(() => {
        setForm('validationModal', false);
    }, [setForm]);

    const handleValidationOptionsChange = React.useCallback(
        (e, { value, checked }) => {
            setForm(value, checked);
        },
        [setForm]
    );

    const isEmailingBlocked = useIsEmailingBlocked();

    const displayPaymentLinkCheckbox = React.useMemo(() => {
        return feature_flags.includes('EO_PAYLINK') && isValidEmail(form.buyer_form['ws-5']) && form.status === 'reservation';
    }, [form, feature_flags, isValidEmail]);

    React.useEffect(() => {
        if (order && !form.attendees.length) {
            onConstructAttendees();
        }
    }, [order, form.attendees]);

    return (
        <>
            <Modal
                allowExternalClosing={false}
                size="medium"
                open={form.validationModal}
                onClose={handleCancel}
                submitButton={<Button disabled={isSubmitting} primary label={t('ticket.common.action.save')} onClick={handleSubmit} />}
                cancelButton={<Button disabled={isSubmitting} label={t('ticket.common.action.cancel')} onClick={handleCancel} />}
                title={t('attendees.addAttendees.modal.title')}
                subtitle={t('attendees.addAttendees.modal.subtitle')}
            >
                {isSubmitting ? (
                    <LoadingCard loading />
                ) : (
                    <>
                        <CheckboxLabel label={t('attendees.addAttendees.modal.download')} value="downloadPDF" onChange={handleValidationOptionsChange} />
                        {isValidEmail(form.buyer_form['ws-5']) && (
                            <CheckboxLabel label={t('attendees.addAttendees.modal.send')} disabled={isEmailingBlocked} value="sendEmail" onChange={handleValidationOptionsChange} />
                        )}
                        {displayPaymentLinkCheckbox && (
                            <CheckboxLabel label={t('attendees.addAttendees.modal.sendPaymentLink')} value="sendPaymentRequest" onChange={handleValidationOptionsChange} />
                        )}
                    </>
                )}
            </Modal>
        </>
    );
}

export default ValidationModal;
